import styled from 'styled-components'
import { Form } from 'formik'

import CommonLink from 'components/Button/CommonLink'
import theme from 'theme_'
import { Regular } from 'components/Typography'

export const StyledLoginForm = styled(Form)`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 347px;
  padding: 5px;
  margin: 0 auto;

  @media ${theme.devices.tablet} {
    max-width: 471px;
    padding: 0;
  }

  @media ${theme.devices.mobile} {
    padding 28px 24px;
  }
`

export const ForgotPasswordWrapper = styled.div`
  text-align: right;
  margin-bottom: ${theme.spacing.md};
`
export const ForgotPasswordLink = styled(CommonLink)`
  color: ${theme.colors.horizonOrange};
  font-weight: 700;
`

export const StyledTermsAndPolicyText = styled(Regular)`
  margin-top: ${theme.spacing.md};
  text-align: center;
`
export const SubmitLoginWrapper = styled.div`
  display: flex;
  justify-content: center;

  @media ${theme.devices.mobile} {
    & > * {
      width: 100%;
    }
  }
`

export const StyledTermsLink = styled.a`
  color: ${theme.colors.horizonOrange};
  text-decoration: none;

  &:hover {
    opacity: 0.8;
  }
`

export const ErrorWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 14px;
  margin-top: 40px;
  margin-bottom: 40px;
`

export const ReturnWrapper = styled.div`
  margin: 0 auto;
  margin-top: 12px;
  width: 60%;
  display: flex;
  justify-content: center;
  gap: 16px;
  & > * {
    flex: 1;
  }

  @media ${theme.devices.mobile} {
    width: inherit;
    margin: 0 24px;
    margin-top: 12px;
    & > * {
      width: 100%;
    }
  }
`

export const ReturnErrorWrapper = styled.div`
  margin: 0 auto;
  margin-top: 12px;
  width: 60%;
  display: flex;
  justify-content: center;
  gap: 16px;

  @media ${theme.devices.mobile} {
    width: inherit;
    margin: 0 24px;
    margin-top: 12px;
    & > * {
      width: 100%;
    }
  }
`
